module.exports = __webpack_public_path__ + "img/715.a4721382.png";